import { render, staticRenderFns } from "./NoSavedEventList.vue?vue&type=template&id=0bfb3fce&"
import script from "./NoSavedEventList.vue?vue&type=script&lang=js&"
export * from "./NoSavedEventList.vue?vue&type=script&lang=js&"
import style0 from "./NoSavedEventList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports